import { Text } from "@/components/ui/text";
import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import React, { useState } from "react";
import i18n from "i18n-js";
import { backendRequest } from "@/stores/thunks";
import { useDispatch } from "react-redux";
import CancelButton from "@/components/basic/CancelButton";
import BasicButton from "@/components/basic/BasicButton";
import InfoReport from "@/components/common/InfoReport";

export default function ModalReport({ route, navigation }) {
    const dispatch = useDispatch()

    const { taskid } = route.params
    let [type, setType] = useState(null);
    let [info, setInfo] = useState('');
    return (
        <View className="flex-1 bg-secondary-300 justify-center">
            <VStack space='sm' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <Text className="text-2xl font-[600] text-secondary-900 bg-secondary-50">{i18n.t('report.title')}</Text>
                <Text className="text-lg my-2 font-[600] text-secondary-900 bg-secondary-50">{i18n.t('report.reason')}</Text>
                <InfoReport type={type} setType={setType} info={info} setInfo={setInfo} />
                <BasicButton bg='bg-error-600' isDisabled={type == null}
                    onPress={() => {
                        dispatch(backendRequest('REPORT_WF', '/report/workflow/' + taskid, {
                            reportComment: info,
                            reportType: type,
                            studioTask: false
                        }, 'POST', true)); navigation.goBack()
                    }} text={i18n.t('report.send')} />
                <CancelButton onPress={() => { navigation.goBack() }} text={i18n.t('report.cancel')} />
            </VStack>
        </View>
    );
}
